import ErrorPage from "@/components/pages/ErrorPage";
import { ConsentCompleteView } from "@/features/consent/components/ConsentCompleteView";
import { loadConsentCompletePage } from "@/features/consent/utils/consentCompleteLoader";
import { createFileRoute } from "@tanstack/react-router";

function DiaryConsentCompletePage() {
    const { consentId, diaryId } = Route.useParams();

    return <ConsentCompleteView consentId={consentId} diaryId={diaryId} routeContext="diaries" />;
}

export const Route = createFileRoute("/_app/diaries/$diaryId/setup/consent/$consentId/complete")({
    component: DiaryConsentCompletePage,
    errorComponent: ({ error, reset }) => <ErrorPage error={error as Error} reset={reset} />,
    loader: async ({ context: { queryClient, auth }, params }) =>
        loadConsentCompletePage({
            queryClient,
            consentId: params.consentId,
            diaryId: params.diaryId,
            userId: auth?.id,
            routeContext: "diaries",
            invalidRedirect: {
                to: "/diaries/$diaryId/home/to-do",
                params: { diaryId: params.diaryId },
            },
        }),
});
